<template>
  <nav class="navbar navbar-dark navigation-container sticky-top p-2">
    <div>
      <img class="img-fluid" alt="" style="max-height: 35px;" src="https://medicalalley.org/wp-content/uploads/2023/04/MAA_Logo_Outlined_Mark_White.png">
    </div>
    <div class="d-flex align-items-center justify-content-center flex-fill">
      <div class="d-flex align-items-center search-container">
        <b-form-input class="search-input" v-model="nameToSearch" @change="(e) => this.addQueryParam('account_name', e)" placeholder="Search for organizations"></b-form-input>
        <i class="fas fa-search p-2" @click="submitQuery" style="cursor: pointer"></i>
      </div>
    </div>
    <div class="ml-auto maadi-link">
      <router-link to="/">
        Back to MAADI
      </router-link>
    </div>
  </nav>
</template>

<script>
import MedicalAlleyStartsMixin from './MedicalAlleyStartsMixin'
export default {
  name: 'medical_alley_starts_navigation',
  mixins: [MedicalAlleyStartsMixin],
  data: function () {
    return {
      nameToSearch: ''
    }
  },
  methods: {
    submitQuery () {
      this.nameToSearch = ''
      this.$emit('queryChanged')
    }
  }
}
</script>

<style scoped>
  .navigation-container {
    background: #EAB339;
    border-bottom: solid 1px #BD7100;
    color: #FFFFFF;
  }
  .search-container {
    width: 600px;
  }
  .search-input {
    border: none;
  }
  .maadi-link a {
    color: #FFFFFF
  }
</style>



// WEBPACK FOOTER //
// src/components/medicalAlleyStarts/Navigation.vue